import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  
  return (
        <footer className="bg-gray-900 text-white py-12">
                <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div>
                    <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
                    <p>Email: swarnbhandargold@gmail.com</p>
                    <p>Phone: +91 7032617511
                              +91 6375685054
                              
                    </p>
                    </div>
                    <div>
                    <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
                    <ul className="space-y-2">
                        <li><a href="/about" className="hover:text-yellow-500">About Us</a></li>
                        <li><a href="/contact" className="hover:text-yellow-500">Contact</a></li>
                        <li><a href="/pricing" className="hover:text-yellow-500">Pricing</a></li>
                    </ul>
                    </div>
                    <div>
                    <h3 className="text-xl font-semibold mb-4">Follow Us</h3>
                    <div className="flex space-x-4">
                        <a href="#" className="hover:text-yellow-500">Facebook</a>
                        <a href="#" className="hover:text-yellow-500">Twitter</a>
                        <a href="#" className="hover:text-yellow-500">LinkedIn</a>
                    </div>
                    </div>
                </div>
                <div className="border-t border-gray-800 mt-8 pt-8 text-center">
                    <p>&copy; 2025 SwarnBhandar. All rights reserved.</p>
                </div>
                </div>
            </footer>
        );
        };

export default Footer;